<template>
  <div class="inputTopic" @click="data.show = false">
    <div class="body layout-col" @click.stop="" :class="{ zoom_body: zoom }">
      <van-nav-bar
        class="nav"
        v-if="zoom"
        :title="option.title"
        left-text="取消"
        :right-text="option.ok_text"
        @click-left="onClickLeft"
        @click-right="ok"
      />
      <img
        v-if="!zoom"
        class="zoom"
        @click="zoom = !zoom"
        src="../image/zoom_out_icon.png"
        alt=""
      />
      <textarea
        name=""
        id=""
        v-model="text"
        ref="text"
        :placeholder="option.placeholder"
        autofocus="autofocus"
      ></textarea>
      <div
        v-if="option.comment"
        style="padding: 5px 0.75rem"
        class="comment font-12-333"
      >
        <span class="spanclamp"> 评论:{{ option.comment }}</span>
      </div>
      <div class="layout-row but">
        <van-uploader
          v-if="option.show_img"
          preview-size="23"
          :max-count="1"
          v-model="fileList"
          multiple
          :after-read="afterRead"
          ><img
            style="width: 23px; height: 23px"
            src="../image/ico_send_photo.png"
            alt=""
        /></van-uploader>
        <div>
          <van-checkbox
            class="font-12-666"
            v-if="noteCheckbox"
            v-model="noteChecked"
            shape="square"
            icon-size="14"
            >同步至评论区，找到更多志同道合小伙伴</van-checkbox
          >
        </div>
        <div v-if="!zoom" class="ok" @click="ok()">{{ option.ok_text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../http/commentImg";
export default {
  props: ["data"],
  data() {
    return {
      noteCheckbox: false,
      noteChecked: false,
      text: "",
      zoom: false,
      fileList: [],
      list: [
        {
          title: "写评论",
          placeholder:
            "你说的或许就是别人想知道的~ 评论不能少于3个字；无意义评论将会被删除",
          ok_text: "发送",
          show_img: true,
          tips: "缺少评论内容",
        },
        {
          title: "笔记",
          placeholder: "好记性不如烂笔头,快来写笔记吧",
          ok_text: "确定",
          show_img: false,
          tips: "缺少笔记内容",
        },
      ],
      option: {},
      commentImg: "",
    };
  },
  created() {
    if (this.data.value) {
      this.text = this.data.value;
    }

    this.option = this.list[this.data.type || 0];

    if (this.data.placeholder) {
      this.option.placeholder = this.data.placeholder;
    }
    if (this.data.type == 1) {
      //笔记编辑
      if (this.data.add == 1) {
        this.option.comment = this.data.item.comment_content;
        this.text = this.data.item.content;
      }
      // 添加笔记
      if (this.data.add == 0) {
        this.noteCheckbox = true;
        this.text = "";
      }
      // 抄笔记
      if (this.data.add == 2) {
        // this.data.add == 0;
        this.text = this.data.item.content;
      }
    }
  },
  mounted() {
    this.$refs.text.focus();
  },
  methods: {
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      let param = new FormData(); // 创建form对象
      param.append("commentImg", file.file); // 通过append向form对象添加数据
      axios.post("/comment/upload_img", param).then((res) => {
        if (res.code == 200) {
          this.fileList[0].commentImg = res.data;
          this.commentImg = res.data;
        }
      });
    },
    ok() {
      if (this.data.type == 1) {
        if (this.text == "" && this.data.add == 1) {
          this.del_note();
          return;
        }
      }

      if (this.text == "") {
        this.$toast.center(this.option.tips);
        return;
      }
      if (this.text.length < 3) {
        this.$toast.center("至少三个字符");
        return;
      }
      this.data.show = false;
      this.data.value = this.text;
      if (this.fileList.length > 0) {
        this.data.commentImg = this.fileList[0].commentImg;
      }

      if (this.data.type == 1) {
        this.buji();
        if (this.noteChecked) {
          this.data.set_type = 0;
        } else {
          return;
        }
      }
      this.$emit("ok", this.data);
    },
    del_note() {
      let item = this.data.item;
      let url = "/note/del_note";
      if (this.$route.query.source == 2) {
        url = "/tiku/del_sheet_question_note";
      }
      this.$axios
        .post(url, {
          // question_id: item.question_id,
          // tab_key: item.tab_key,
          // content: this.data.value,
          // type: 1,
          // comment_id: item.comment_id,
          note_id: item.id,
          sheet_id: this.$route.query.sheet_id,
          sheet_type: this.$route.query.sheet_type,
          //           comment_id
        })
        .then((res) => {
          this.data.show = false;
          this.$emit("del_note", item.id);
          if (res.code == 200) {
            if (this.data.add == 1) {
              this.$toast.center("删除笔记成功");
            }
          }
        });
    },
    buji() {
      let item = this.data.item;

      //   笔记类型（1：题库笔记 2：题库评论笔记 3：必备考点 4：必备考点评论）5每日一练 6 每日一练评论
      let url = "/note/add_note";
      if (this.data.add == 1) {
        url = "/note/update_note";
        item.content = this.data.value;
      }

      if (this.$route.query.source == 2) {
        url = "/tiku/add_sheet_question_note";
        if (this.data.add == 1) {
          url = "/tiku/update_sheet_question_note";
          item.content = this.data.value;
        }
      }
      if (!item.tab_key) {
        item.tab_key = this.$route.query.tab_key;
      }
      let type = 1;
      if (this.data.is_comment == 1) {
        type = 2;
      }
      if (item.tab_key == "test_center") {
        type = 3;
        if (this.data.is_comment == 1) {
          type = 4;
        }
      }
      if (item.tab_key == "daily_question") {
        type = 5;
        if (this.data.is_comment == 1) {
          type = 6;
        }
      }

      this.$axios
        .post(url, {
          question_id: item.question_id,
          tab_key: item.tab_key,
          sheet_id: this.$route.query.sheet_id,
          sheet_type: this.$route.query.sheet_type,
          content: this.data.value,
          type,
          comment_id: this.data.add == 2 ? "" : item.comment_id,
          note_id: item.id,
          //           comment_id
        })
        .then((res) => {
          if (res.code == 200) {
            if (this.data.add == 1) {
              this.$toast.center("修改笔记成功");
            }
            this.$store.commit("topic/add_note", item.question_id);
            if (item.is_note == 0) {
              item.is_note = 1;
            }
          }
        });
    },
    onClickLeft() {
      this.data.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.ico_send_photo {
  width: 23px;
  height: 23px;
  overflow: hidden;
  img {
    width: 23px;
    height: 23px;
  }
}
.inputTopic {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.4);
  z-index: 4;
}

.body {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  //   padding: 1.75rem 0.75rem 0 0.75rem;
  padding-top: 1.75rem;
  box-sizing: border-box;
  .zoom {
    position: absolute;
    top: 0rem;
    right: 0.25rem;
    border: 0.5rem solid rgba($color: #000000, $alpha: 0);
    width: 0.75rem;
    height: 0.75rem;
  }
  textarea {
    width: calc(100% - 1.5rem);
    margin: 0 0.75rem;
    background: #f6f6f6;
    height: 4.5rem;
    padding: 0.75rem 0.55rem;
    box-sizing: border-box;
    border: none;
    font-size: 0.7rem;
  }

  textarea::-webkit-input-placeholder {
    font-size: 0.7rem;
    color: #999999;
  }
  .but {
    margin: 0 0.75rem;
    height: 2.5rem;
    align-items: center;
    .ok {
      margin-left: auto;
      width: 2.75rem;
      text-align: center;
      height: 1.25rem;
      line-height: 1.25rem;
      background: #3982f7;
      border-radius: 0.2rem;
      font-size: 0.7rem;
      color: #fff;
    }
  }
}
.zoom_body {
  height: 100%;
  padding-top: 0;
  textarea {
    height: 100%;
    margin-top: 0.75rem;
  }
}
>>> .van-nav-bar__left .van-nav-bar__text {
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/inputTopic.vue